import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { oidcConfig } from './auth/oidc';
import { Toaster } from './components/Toast';
import { ConfirmHost } from './components/ConfirmDialog';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
// Leaflet's default marker icons are resolved relative to its CSS,
// which Vite breaks during bundling — point them at the package's
// images via Vite's asset pipeline so markers render in production.
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import './index.css';

interface DefaultIconProto { _getIconUrl?: unknown }
delete (L.Icon.Default.prototype as DefaultIconProto)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry once on transient failures (e.g. cold app-runner instance).
      retry: 1,
      // Background refetches are governed per-query via refetchInterval.
      refetchOnWindowFocus: true,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <StrictMode>
    <AuthProvider {...oidcConfig}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Toaster>
            <ConfirmHost>
              <App />
            </ConfirmHost>
          </Toaster>
        </BrowserRouter>
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
);
